document.addEventListener('DOMContentLoaded', function () {
  var animatedSections = document.querySelectorAll('[data-jblp-animate]');

  if ('IntersectionObserver' in window && animatedSections.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    animatedSections.forEach(function (section) {
      observer.observe(section);
    });
  } else {
    animatedSections.forEach(function (section) {
      section.classList.add('visible');
    });
  }

  var packButtons = document.querySelectorAll('[data-jblp-pack-button]');
  var productCards = document.querySelectorAll('[data-jblp-product-card]');
  var heroCta = document.getElementById('jblp-hero-atc');
  var stickyVariant = document.getElementById('jblp-sticky-variant');
  var stickyPrice = document.getElementById('jblp-sticky-price');
  var stickyBar = document.getElementById('jblp-sticky-bar');
  var packData = {
    three: {
      label: '3-Pack',
      priceDisplay: '$35.99'
    },
    six: {
      label: '6-Pack',
      priceDisplay: '$44.99'
    }
  };

  productCards.forEach(function (card) {
    var pack = card.getAttribute('data-jblp-pack');
    var priceDisplay = card.getAttribute('data-jblp-price-display');

    if (pack && priceDisplay) {
      packData[pack] = packData[pack] || {};
      packData[pack].priceDisplay = priceDisplay;
    }
  });

  function updatePackButtonDisplay(button) {
    var pack = button.getAttribute('data-jblp-pack');
    var priceNode = button.querySelector('.var-price');
    var data = packData[pack];

    if (!data || !priceNode) {
      return;
    }

    priceNode.textContent = data.priceDisplay;
    button.setAttribute('data-jblp-price-display', data.priceDisplay);
  }

  function syncSelectedPack(button) {
    var label = button.getAttribute('data-jblp-label') || '';
    var priceDisplay = button.getAttribute('data-jblp-price-display') || '';

    packButtons.forEach(function (item) {
      item.classList.remove('selected');
    });

    button.classList.add('selected');

    if (heroCta) {
      heroCta.textContent = 'Get the ' + label + ' - ' + priceDisplay;
    }

    if (stickyVariant) {
      stickyVariant.textContent = label;
    }

    if (stickyPrice) {
      stickyPrice.textContent = priceDisplay;
    }
  }

  packButtons.forEach(function (button) {
    updatePackButtonDisplay(button);

    button.addEventListener('click', function () {
      syncSelectedPack(button);
    });
  });

  var defaultSelectedButton = document.querySelector('[data-jblp-pack-button].selected');

  if (defaultSelectedButton) {
    syncSelectedPack(defaultSelectedButton);
  } else if (packButtons.length) {
    syncSelectedPack(packButtons[0]);
  }

  if (stickyBar) {
    var heroEl = document.getElementById('jblp-hero-top');
    var finalCtaEl = document.querySelector('.final-cta');

    function updateStickyVisibility() {
      if (!heroEl) {
        stickyBar.classList.toggle('visible', window.scrollY > 500);
        return;
      }

      var heroBottom = heroEl.getBoundingClientRect().bottom;
      var pastHero = heroBottom < 0;

      var beforeFinalCta = true;
      if (finalCtaEl) {
        beforeFinalCta = finalCtaEl.getBoundingClientRect().top > window.innerHeight * 0.85;
      }

      stickyBar.classList.toggle('visible', pastHero && beforeFinalCta);
    }

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    updateStickyVisibility();
  }

  // Drag-to-scroll for review strip
  var reviewWrap = document.getElementById('jblp-review-wrap');
  var reviewStrip = document.getElementById('jblp-review-strip');

  if (reviewWrap && reviewStrip) {
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    reviewWrap.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX;
      scrollStart = reviewStrip.scrollLeft;
      reviewWrap.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      reviewStrip.scrollLeft = scrollStart - (e.pageX - startX);
    });

    window.addEventListener('mouseup', function () {
      isDragging = false;
      reviewWrap.classList.remove('is-dragging');
    });

    // Touch support
    reviewWrap.addEventListener('touchstart', function (e) {
      startX = e.touches[0].pageX;
      scrollStart = reviewStrip.scrollLeft;
    }, { passive: true });

    reviewWrap.addEventListener('touchmove', function (e) {
      reviewStrip.scrollLeft = scrollStart - (e.touches[0].pageX - startX);
    }, { passive: true });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetId = link.getAttribute('href');
      var target = document.querySelector(targetId);

      if (!target) {
        return;
      }

      event.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});
